<form #form="ngForm">
    <ui-banner variant="warning">
        <p>{{ 'time-off-v3.theseSettingsMayHaveAccountingComplianceAndLegalImplications' | translate }}</p>
    </ui-banner>
    <h4>
        {{ 'time-off-v3.seniorityIncrease' | translate }}
        <ui-info class="margin-info" [text]="advancedFormTooltips.seniorityOverrides"></ui-info>
    </h4>
    <ng-container *ngFor="let seniorityOverride of timeOffSeniorityOverrides; let i = index">
        <div class="app-grid grid-center seniority-wrapper">
            <div class="columns-5 large-columns-12 flex middle">
                <p class="no-margin-bottom">{{ 'time-off-v3.after' | translate }}</p>
                <mat-form-field class="margin-left seniority-fields">
                    <input
                        [(ngModel)]="seniorityOverride.afterNumberOfYears"
                        name="year_{{ i }}"
                        #year="ngModel"
                        placeholder="{{ 'time-off-v3.years' | translate }}"
                        required
                        matInput
                    />
                    <mat-error *ngIf="year.invalid">{{ year.errors | formErrors }}</mat-error>
                </mat-form-field>
                <p class="no-margin-bottom margin-left">
                    {{ 'time-off-v3.yearsIncreaseAmountAccruedPerYearTo' | translate }}
                </p>
            </div>
            <div class="columns-5 large-columns-10 flex middle">
                <mat-form-field class="seniority-fields">
                    <input
                        [ngModel]="getDaysAccruedPerPeriod(seniorityOverride)"
                        (ngModelChange)="setDaysAccruedPerPeriod(seniorityOverride, $event)"
                        name="daysAccrued_{{ i }}"
                        #daysAccrued="ngModel"
                        placeholder="{{ timeOffPolicy.timeOffType.unitOfTimeSingular | titlecase }}"
                        required
                        matInput
                    />
                    <mat-hint align="end"
                        >{{
                            getAccruedValuePerPeriod(seniorityOverride.daysAccruedPerPeriod)
                                | number: decimalPlacesForPipe
                        }}
                        {{ timeOffPolicy.timeOffType.unitOfTimePlural | titlecase }} per period</mat-hint
                    >
                    <mat-error *ngIf="daysAccrued.invalid">{{ daysAccrued.errors | formErrors }}</mat-error>
                </mat-form-field>
                <p class="margin-left no-margin-bottom">{{ timeOffPolicy.timeOffType.unitOfTimePlural | titlecase }}</p>
            </div>
            <div class="columns-2 large-columns-2 flex flex-end">
                <ui-button (click)="removeSeniorityOverride(i)" type="ghost">{{
                    'time-off-v3.xRemove' | translate
                }}</ui-button>
            </div>
        </div>
    </ng-container>
    <div class="add-level">
        <ui-button (click)="addSeniorityOverride()" type="link">{{ 'time-off-v3.addLevel' | translate }}</ui-button>
    </div>

    <div class="ui divider"></div>

    <div class="caps">
        <div class="cap">
            <div class="app-grid">
                <mat-slide-toggle
                    class="columns-1"
                    [(ngModel)]="timeOffPolicy.proratesFirstAccrual"
                    name="slideToggle"
                    color="primary"
                >
                </mat-slide-toggle>
                <h4 class="columns-3 large-columns-6 no-margin">
                    {{ 'time-off-v3.prorateFirstAccrual' | translate }}
                    <ui-info class="margin-info" [text]="advancedFormTooltips.proratesFirstAccrual"></ui-info>
                </h4>
            </div>
        </div>

        <div class="cap">
            <div class="app-grid slider">
                <mat-slide-toggle
                    class="columns-1"
                    [checked]="showYearEndBalanceCap"
                    (change)="showYearEndBalanceCap = $event.checked; resetCarryoverDateValues(); setYearEndCapDate()"
                    name="slideToggle"
                    color="primary"
                >
                </mat-slide-toggle>
                <h4 class="columns-3 large-columns-6 no-margin flex">
                    {{ 'time-off-v3.yearEndBalanceCap' | translate }}
                    <ui-info class="margin-info" [text]="advancedFormTooltips.yearEndBalanceCap"></ui-info>
                </h4>
            </div>
            <div *ngIf="showYearEndBalanceCap">
                <div class="app-grid grid-center form-field-margin-bottom">
                    <label class="columns-2">{{ 'time-off-v3.capAtStar' | translate }}</label>
                    <mat-form-field class="no-labels no-helpers columns-2">
                        <input
                            [(ngModel)]="timeOffPolicy.carryoverCap"
                            name="carryoverCap"
                            #carryoverCap="ngModel"
                            placeholder="{{ 'time-off-v3.capAt' | translate }}"
                            matInput
                            required
                        />
                    </mat-form-field>
                    <p class="no-margin-bottom margin-left-days columns-1">
                        {{ this.timeOffPolicy.timeOffType?.unitOfTimePlural | titlecase }}
                    </p>
                </div>
                <div class="app-grid grid-center form-field-margin-bottom">
                    <label class="columns-2 large-columns-4">{{ 'time-off-v3.capOnDate' | translate }}</label>
                    <mat-form-field class="columns-2 large-columns-7 no-labels no-helpers">
                        <mat-select
                            name="capOnDate"
                            #capOnDate
                            [ngModel]="getCapOnDate()"
                            [placeholder]="'Cap on date'"
                            (selectionChange)="onCapOnDateSelectionChange($event)"
                            required
                        >
                            <mat-option [value]="yearEnd">{{ 'time-off-v3.yearEnd' | translate }} </mat-option>
                            <mat-option [value]="hired"
                                >{{ 'time-off-v3.dateHiredAnniversary' | translate }}
                            </mat-option>
                            <mat-option [value]="pickADate">{{ 'time-off-v3.pickADate' | translate }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <ng-container *ngIf="capOnDate?.triggerValue === pickADate">
                    <div class="app-grid grid-center form-field-margin-bottom">
                        <label class="columns-2 large-columns-4">{{ 'time-off-v3.day' | translate }}</label>
                        <mat-form-field class="no-labels no-helpers columns-2">
                            <mat-select
                                name="day"
                                #day="ngModel"
                                [placeholder]="'Day'"
                                [ngModel]="getCarryOverDay()"
                                (ngModelChange)="carryOverDay = $event; setCarryoverDate($event)"
                                required
                            >
                                <mat-option *ngFor="let day of daysInMonth" [value]="day">{{
                                    day > 0 ? (day | ordinalNumber) : ('time-off-v3.lastDay' | translate)
                                }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="app-grid grid-center form-field-margin-bottom">
                        <label class="columns-2 large-columns-4">{{ 'time-off-v3.month' | translate }}</label>
                        <mat-form-field class="columns-2 large-columns-7 no-labels no-helpers">
                            <mat-select
                                name="month"
                                #month="ngModel"
                                placeholder="{{ 'time-off-v3.month' | translate }}"
                                [ngModel]="getCarryOverMonth()"
                                (ngModelChange)="carryOverMonth = $event; setCarryoverMonth($event)"
                                required
                            >
                                <mat-option *ngFor="let month of months" [value]="month.value">{{
                                    month.label | translate
                                }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </ng-container>

                <div class="app-grid grid-center form-field-margin-bottom">
                    <label class="columns-2 large-columns-4">{{ 'time-off-v3.expireAfterDays' | translate }}</label>
                    <mat-form-field class="columns-2 no-labels no-helpers">
                        <input
                            name="expiryAfter"
                            #expiryAfter="ngModel"
                            placeholder="{{ 'time-off-v3.days' | translate }}"
                            [(ngModel)]="timeOffPolicy.carryoverExpireAfter"
                            matInput
                        />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="cap">
            <div class="app-grid slider">
                <mat-slide-toggle
                    class="columns-1"
                    [checked]="showMaxBalanceCap"
                    (change)="showMaxBalanceCap = $event.checked; timeOffPolicy.balanceCap = null"
                    name="slideToggle"
                    color="primary"
                >
                </mat-slide-toggle>
                <h4 class="columns-3 large-columns-6 no-margin flex">
                    {{ 'time-off-v3.maxBalanceCap' | translate }}
                    <ui-info class="margin-info" [text]="advancedFormTooltips.maxBalanceCap"></ui-info>
                </h4>
            </div>
            <div *ngIf="showMaxBalanceCap">
                <div class="app-grid align-baseline">
                    <label class="columns-2">{{ 'time-off-v3.capAtStar' | translate }}</label>
                    <mat-form-field class="columns-2 no-labels">
                        <input
                            type="number"
                            min="0"
                            [(ngModel)]="timeOffPolicy.balanceCap"
                            name="maxCapAt"
                            #maxCapAt="ngModel"
                            placeholder="{{ 'time-off-v3.capAt' | translate }}"
                            required
                            matInput
                        />
                        <mat-error *ngIf="maxCapAt.invalid">{{ maxCapAt.errors | formErrors }}</mat-error>
                    </mat-form-field>
                    <p class="no-margin-bottom columns-1">
                        {{ this.timeOffPolicy.timeOffType?.unitOfTimePlural | titlecase }}
                    </p>
                </div>
            </div>
        </div>

        <div class="cap">
            <div class="app-grid slider">
                <mat-slide-toggle
                    class="columns-1"
                    [checked]="showNegativeBalanceCap"
                    (change)="showNegativeBalanceCap = $event.checked; requestRules.negativeBalanceCap = 0"
                    name="slideToggle"
                    color="primary"
                >
                </mat-slide-toggle>
                <h4 class="columns-3 large-columns-6 no-margin flex">
                    {{ 'time-off-v3.allowNegativeBalances' | translate }}
                    <ui-info class="margin-info" [text]="advancedFormTooltips.allowNegativeBalanceCap"></ui-info>
                </h4>
            </div>
            <div *ngIf="showNegativeBalanceCap">
                <div class="app-grid align-baseline">
                    <label class="columns-2">{{ 'time-off-v3.capAt' | translate }}</label>
                    <mat-form-field class="no-labels columns-2">
                        <input
                            type="number"
                            placeholder="{{ 'time-off-v3.positiveNumberEgNine' | translate }}"
                            min="0"
                            [(ngModel)]="requestRules.negativeBalanceCap"
                            name="negCapAt"
                            #negCapAt="ngModel"
                            required
                            matInput
                        />
                        <mat-error *ngIf="negCapAt.invalid">{{ negCapAt.errors | formErrors }}</mat-error>
                    </mat-form-field>
                    <p class="no-margin-bottom columns-3">
                        {{ timeOffPolicy.timeOffType?.unitOfTimePlural | titlecase }} over
                    </p>
                </div>
            </div>
        </div>

        <div class="cap">
            <div class="app-grid slider">
                <mat-slide-toggle
                    class="columns-1"
                    [checked]="showWaitingPeriod"
                    (change)="showWaitingPeriod = $event.checked; requestRules.waitingPeriod = 0"
                    name="slideToggle"
                    color="primary"
                >
                </mat-slide-toggle>
                <h4 class="columns-2 large-columns-6 no-margin flex">
                    {{ 'time-off-v3.waitingPeriod' | translate }}
                    <ui-info class="margin-info" [text]="advancedFormTooltips.waitingPeriod"></ui-info>
                </h4>
            </div>
            <div *ngIf="showWaitingPeriod">
                <div class="app-grid align-baseline">
                    <label class="columns-2">{{ 'time-off-v3.duration' | translate }}</label>
                    <mat-form-field class="no-labels columns-2">
                        <input
                            type="number"
                            min="0"
                            [(ngModel)]="requestRules.waitingPeriod"
                            name="waitingPeriod"
                            #waitingPeriod="ngModel"
                            placeholder="{{ 'time-off-v3.duration' | translate }}"
                            required
                            matInput
                        />
                        <mat-error *ngIf="waitingPeriod.invalid">{{ waitingPeriod.errors | formErrors }}</mat-error>
                    </mat-form-field>
                    <p class="no-margin-bottom columns-3">{{ 'time-off-v3.daysAfterHireDate' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="cap">
            <div class="app-grid slider">
                <mat-slide-toggle
                    class="columns-1"
                    [checked]="showLimitRequest"
                    (change)="
                        showLimitRequest = $event.checked; requestRules.minDayAmount = 0; requestRules.maxLength = null
                    "
                    name="slideToggle"
                    color="primary"
                >
                </mat-slide-toggle>
                <h4 class="columns-3 large-columns-6 no-margin flex">
                    {{ 'time-off-v3.limitRequestLength' | translate }}
                    <ui-info class="margin-info" [text]="advancedFormTooltips.limitRequestLength"></ui-info>
                </h4>
            </div>
            <div *ngIf="showLimitRequest">
                <div class="app-grid align-baseline form-field-margin-bottom">
                    <label class="columns-2">{{ 'time-off-v3.minDayLength' | translate }}</label>
                    <mat-form-field class="no-labels columns-2">
                        <input
                            [(ngModel)]="requestRules.minDayAmount"
                            min="0"
                            type="number"
                            name="min"
                            #min="ngModel"
                            placeholder="{{ 'time-off-v3.min' | translate }}"
                            required
                            matInput
                        />
                        <mat-error *ngIf="min.invalid">{{ min.errors | formErrors }}</mat-error>
                    </mat-form-field>
                    <p class="no-margin-bottom columns-1">
                        {{ timeOffPolicy.timeOffType?.unitOfTimePlural | titlecase }}
                    </p>
                </div>

                <div class="app-grid align-baseline">
                    <label class="columns-2">{{ 'time-off-v3.maxTotalLength' | translate }}</label>
                    <mat-form-field class="no-labels columns-2">
                        <input
                            [(ngModel)]="requestRules.maxLength"
                            min="0.25"
                            type="number"
                            name="max"
                            #max="ngModel"
                            placeholder="{{ 'time-off-v3.max' | translate }}"
                            matInput
                        />
                        <mat-error *ngIf="max.invalid">{{ max.errors | formErrors }}</mat-error>
                    </mat-form-field>
                    <p class="no-margin-bottom columns-1">
                        {{ timeOffPolicy.timeOffType?.unitOfTimePlural | titlecase }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</form>
